import {useEffect, useState} from 'react';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import ProvinceShow from './province-show';
import ProvinceForm from './province-form';

function ProvincePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const {provinceId} = useParams();
  // The list page passes its own URL (with the active filters) in the router
  // state so going back to it keeps the search text and the country filter.
  const listLocation = location.state?.from || '/contacts/provinces';
  const isNew = provinceId === 'new';
  const [mode, setMode] = useState(isNew ? 'edit' : 'show');
  // Used to force-remount ProvinceShow after a successful save so it refetches.
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    if (!isNew) setMode('show');
  }, [provinceId, isNew]);

  const goToList = () => navigate(listLocation);

  if (isNew) {
    return (
      <ProvinceForm
        provinceId="new"
        onCancel={goToList}
        onSaved={(saved) => {
          if (saved?.id) navigate(`/contacts/provinces/${saved.id}`, {state: {from: listLocation}});
          else goToList();
        }}
      />
    );
  }

  if (mode === 'show') {
    return (
      <ProvinceShow
        key={`show-${reloadKey}`}
        provinceId={provinceId}
        onEdit={() => setMode('edit')}
        onList={goToList}
      />
    );
  }

  return (
    <ProvinceForm
      provinceId={provinceId}
      onCancel={() => setMode('show')}
      onSaved={() => {
        setReloadKey((k) => k + 1);
        setMode('show');
      }}
    />
  );
}

export default ProvincePage;
